import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { authReducer } from './reducers/auth';
import { userReducer } from './reducers/user';
import { productReducer, typeFilterReducer } from './reducers/product';

const middleware = [thunk];

const reducer = combineReducers({
  buynsellAuth: authReducer,
  buynsellUser: userReducer,
  buynsellProduct: productReducer,
  typeFilter: typeFilterReducer,
});

const userState = window.localStorage.getItem('buynsell')
  ? JSON.parse(window.localStorage.getItem('buynsell'))
  : null;

const InitialState = {
  buynsellAuth: userState,
  typeFilter: 'imovel',
};

const store = createStore(
  reducer,
  InitialState,
  compose(applyMiddleware(...middleware))
);

export default store;
